import React from 'react';
import classnames from 'classnames';
import {Button} from '@br/br-components';

import StorageAPI from '../../apis/storage_api';
import ErrorMessages from '../atoms/errorMessages';
class PhoneVerify extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      errors: props.errors,
      isCodeValid: true,
      resendCount: 30,
      success: false,
      loading: false,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onVerifyError = this.onVerifyError.bind(this);
    this.onVerifySuccess = this.onVerifySuccess.bind(this);
    this.getPhoneNumber = this.getPhoneNumber.bind(this);
    this.resetCountDown = this.resetCountDown.bind(this);
    this.onCountDown = this.onCountDown.bind(this);
    this.resendCode = this.resendCode.bind(this);
  }

  componentDidMount() {
    this.resendCountDown = global.setInterval(this.onCountDown, 1000);
  }

  componentWillUnmount() {
    global.clearInterval(this.resendCountDown);
  }

  onCountDown() {
    if (this.state.resendCount > 0) {
      this.setState({resendCount: this.state.resendCount - 1});
    } else {
      global.clearInterval(this.resendCountDown);
    }
  }

  moveInput(elem, direction) {
    const nextElement =
      direction === 'backwards' ? elem.previousElementSibling : elem.nextElementSibling;
    // nextElement will be null if there is no next/prev sibling element
    if (nextElement && nextElement.nodeName === 'INPUT') {
      nextElement.focus();
    }
  }

  onChange(event) {
    const elem = event.target;
    elem.value = elem.value.trim(); // remove whitespace
    if (elem.value !== '') {
      this.moveInput(elem);
    }
  }

  onKeyDown(event) {
    // using keydown; nonprintable chars don't trigger keypress
    if (event.key === 'Backspace' && !event.target.value) {
      // hitting Backspace in an empty field; user probably wants to move to previous input
      this.moveInput(event.target, 'backwards');
    }
  }

  async onVerifySuccess() {
    const {onboarding, screen} = this.props;
    if (this.props.onEditUser) {
      this.props.stepCompleted(true, 'editProfile');
    } else if (this.props.stepCompleted) {
      this.setState({success: true});
      await this.props.mParticleLogin(
        {
          email: '',
        },
        {
          loggedIn: true,
          signup_source: 'phone',
          account_verified: true,
        }
      );
      this.props.stepCompleted(true, true, true);
      this.props.trackEvent({
        tag_manager_event: 'account_verified',
        accountType: 'phone',
        screen,
        onboarding,
        legacyInstall: false,
        legacyAccount: false,
      });

      if (this.props.isSignup) {
        this.props.trackEvent({
          tag_manager_event: 'account_created',
          accountType: 'phone',
          success: true,
          socialOnboarding: false,
        });
      }
      this.props.trackAction();
    }
  }

  resetCountDown() {
    this.setState({resendCount: 30});
    this.resendCountDown = global.setInterval(this.onCountDown, 1000);
  }

  onVerifyError(err) {
    const userStatus = err && err.data && err.data.json && err.data.json.user_status;
    let errorMsg;
    switch (userStatus) {
      case null: {
        errorMsg = 'Invalid code, please try again.';
        break;
      }
      case false: {
        errorMsg = 'Account not found.';
        break;
      }
      default: {
        errorMsg = 'Please try again later.';
        break;
      }
    }

    this.setState({errors: [errorMsg]});

    if (this.props.isSignup) {
      this.props.trackEvent({
        tag_manager_event: 'account_created',
        accountType: 'phone',
        success: false,
        socialOnboarding: false,
      });
      this.props.trackEvent({
        tag_manager_event: 'user_error',
        errorType: 'account_management',
        errorMessage: err.output.payload.error || err.message,
        errorCode: err.data.errorCode,
        page: 'phone',
      });
    }
  }

  getPhoneNumber(obscure = false) {
    let phone = this.props.phone || StorageAPI.get('br_phone');
    if (!phone) {
      return false;
    }
    if (obscure) {
      // ie "********34"
      phone = String(phone)
        .split('')
        .map((item, index, arr) => {
          return index < arr.length - 2 ? '*' : item;
        })
        .join('');
    }
    return phone;
  }

  onSubmit(event) {
    event.preventDefault();
    const phone = this.getPhoneNumber();
    const {userID} = this.props;

    this.setState(
      {
        loading: true,
      },
      () => {
        const code = `${this._code1.value}${this._code2.value}${this._code3.value}${this._code4.value}`;
        if (this.props.verifyPhone) {
          this.props
            .verifyPhone({phone, code, userID})
            .then(this.onVerifySuccess)
            .catch(this.onVerifyError);
        }
      }
    );
  }

  resendCode() {
    event.preventDefault();
    const phone = StorageAPI.get('br_phone');
    const {userID} = this.props;
    this.props.trackEvent({
      tag_manager_event: 'resend_verification',
      accountType: 'phone',
    });

    this.props
      .authorizePhone(phone, userID)
      .then(this.resetCountDown)
      .catch(this.onVerifyError);
  }

  getOrdinal(num) {
    const ends = ['th', 'st', 'nd', 'rd'];
    const remain = num % 100;
    return num + (ends[(remain - 20) % 10] || ends[remain] || ends[0]);
  }

  render() {
    const classNames = classnames({
      molecule: true,
      phoneVerify: true,
      success: !!this.state.success,
    });

    const {errors, loading, resendCount, success} = this.state;

    const phone = this.getPhoneNumber(true);
    return (
      <form className={classNames} onSubmit={this.onSubmit}>
        <h2>Enter Your Code</h2>
        <p>A Verification Code was sent to {phone || 'the entered phone number'}.</p>
        <div className="verificationCode">
          {[1, 2, 3, 4].map((indexStartingAtOne) => {
            return (
              <input
                ref={(elem) => {
                  this[`_code${indexStartingAtOne}`] = elem;
                }}
                key={indexStartingAtOne}
                name={`verificationCode${indexStartingAtOne}`}
                type="number"
                inputMode="numeric"
                pattern="^\d$"
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
                required={true}
                title={`${this.getOrdinal(
                  indexStartingAtOne
                )} digit of the code sent to your phone`}
                autoFocus={indexStartingAtOne === 1}
                maxLength={1}
              />
            );
          })}
        </div>
        <ErrorMessages errors={errors} errorSet="phone" />
        {success ? <p className="successMessage">Success!</p> : false}
        <Button type="submit" disabled={loading} loading={loading}>
          Verify
        </Button>
        {resendCount < 1 ? (
          <Button onClick={this.resendCode}>Resend Code</Button>
        ) : (
          <p>Resend code in {resendCount} seconds</p>
        )}
        {this.props.children}
      </form>
    );
  }
}

PhoneVerify.defaultProps = {
  authorizePhone: () => Promise.reject(new Error('No authorizePhone prop passed!')),
  trackAction: () => {},
  errors: [],
};

export default PhoneVerify;
